import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { InlineSvgComponent } from '../inline-svg/inline-svg.component';

export type SpinnerSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'ui-spinner',
  imports: [ CommonModule, InlineSvgComponent ],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'status',
  },
})
export class SpinnerComponent {
  /** Defines the size of the spinner: 16px, 24px or 48px. */
  size = input<SpinnerSize>('medium');
  /**
   * What is being waited for, already translated. Announced when the spinner appears; without it
   * a screen reader reaches a live region with nothing to read out.
   */
  label = input<string>();
}
